import { getColor } from "../color";
export function ArrowRight({ size = 14, color }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill={getColor(color) || color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 1.645L7.94467 7L3 12.355L4.52227 14L11 7L4.52227 0L3 1.645Z"
        fill={getColor(color) || color}
      />
    </svg>
  );
}
